import React, { useMemo, useState } from "react";
import TableContainer from "./TableContainer";
import moment from "moment";
import "./BillingNotesTableStyle.css";
import { useSelector } from "react-redux";
import { getFullName, notify } from "../../../../../util/helpers";
import NotesModal from "./NotesModal";
import BillingNotesPDF from "./BillingNotesPDF";

const CTAComponent = ({ callback1, callback2,callback3,callback4,data }) => {
  return (
    <td style={{ display: "flex", gap: "8px" }}>
      <button className="cta-button" onClick={callback1}>
        View
      </button>
      <button className="cta-button-alt" onClick={callback2}>
        Export PDF
      </button>
      <button className="cta-button-alt" onClick={callback3}>
        Delete
      </button>
      <button className="cta-button-alt" onClick={callback4}>
        Edit
      </button>
    </td>
  );
};

const BillingNotesTable = (props) => {
  const { staffData } = useSelector((state) => state.app);
  const [modalIsOpen, setModalOpen] = useState(false);
  const [data, setData] = useState({});
  const [singleNote, setSingleNote] = useState(false);
// console.log("props.data",props.data);
const columns = useMemo(
    () => [
      {
        Header: "Date Created",
        accessor: "created",
        sortType: (a, b) => {
          return new Date(b?.values?.created) - new Date(a?.values?.created);
        },
        Cell: ({ cell }) => {
          return (
            <small>
              {cell.value
                ? moment(cell.value).format("MMM DD, YYYY")
                : "Not Available"}
            </small>
          );
        },
      },
      {
        Header: "Date Updated",
        accessor: "modified",
        Cell: ({ cell }) => {
          return (
            <small>
              {cell.value
                ? moment(cell.value).format("MMM DD, YYYY")
                : "Not Available"}
            </small>
          );
        },
      },
      {
        Header: "Billing Month",
        accessor: "month",
        Cell: ({ cell }) => {
          return (
            <small>
              {cell.value
                ? (cell.value)
                : "Not Available"}
            </small>
          );
        },
      },
      {
        Header: "Created By",
        accessor: "added_by",
        Cell: ({ cell }) => {
          const added_by_staff = staffData.find((staff) => {
            if (staff.id === cell.value) {
              return staff;
            }
          });
          return (
            <small>
              {added_by_staff ? getFullName(added_by_staff) : "Not available"}
            </small>
          );
        },
      },
      {
        Header: "Activity",
        accessor: "activity",
        Cell: ({ cell }) => {
          return <small>{cell.value || "Not Available"}</small>;
        },
      },
      {
        Header: "Duration",
        accessor: "duration",
        Cell: ({ cell }) => {
          return <small>{cell.value || 0}</small>;
        },
      },
      {
        Header: "Notes",
        accessor: "notes",
        Cell: ({ cell }) => {
          return <small>{cell.value || "Not Available"}</small>;
        },
      },
      {
        Header: " ",
        accessor: (d) => d,
        Cell: ({ cell }) => {
          return (
            <CTAComponent
              callback1={() => {
                setModalOpen(true);
                setData(cell.value);
              }}
              callback2={() => {
                setData(cell.value);
                setSingleNote(true);
                props?.setNotesDownloadMode(true);
                // notify("This feature is coming soon!", "info");
              }}
              callback3={() => {
                setData(cell.value);
                setSingleNote(true);
                props?.setShowDeleteNoteModal(true);
                props.setNoteBeingEdited(cell.value);
              }}
              callback4={() => {
                setData(cell.value);
                setSingleNote(true);
                props.setNoteBeingEdited(cell.value);
                props?.setShowEditNoteModal(true);
              }}
              data={cell?.value}
            />
          );
        },
      },
    ],
    []
  );

  return (
    <>
      <NotesModal
        setIsOpen={setModalOpen}
        modalIsOpen={modalIsOpen}
        data={data}
      />
      <TableContainer
        columns={columns}
        data={props?.data}
        notesFilterValue={props?.notesFilterValue}
      />
      {props?.notesDownloadMode && (
        <>
          <div style={{ height: "100vh" }} />
          <BillingNotesPDF
            startDate={props?.startDate}
            endDate={props?.endDate}
            setNotesDownloadMode={props?.setNotesDownloadMode}
            singleNote={singleNote}
            setSingleNote={setSingleNote}
            singleNoteData={data}
            pdfData={props.data}
            notesFilterValue={props?.notesFilterValue}
          />
        </>
      )}
    </>
  );
};

export default BillingNotesTable;
